import PropTypes, { number } from "prop-types";

// This is a generic WrapperContainer for easier use of margins and paddings as props
const WrapperContainer = ({
  children,
  Container,
  as,
  className,
  m,
  mh,
  mv,
  ml,
  mr,
  mt,
  mb,
  p,
  ph,
  pv,
  pl,
  pr,
  pt,
  pb,
  gap,
  width,
  height,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  alignItems,
  wrap,
  alignSelf,
  position,
  textAlign,
  innerRef,
  top,
  left,
  bottom,
  right,
  zIndex,
  background,
  ...rest
}) => {
  const getStyles = () => {
    let styles = {};

    // margins
    if (m != null) {
      styles.margin = `${m}px`;
    }

    if (mh != null && mv != null) {
      styles.margin = `${mv}px ${mh}px`;
    }

    if (mh != null && !mv) {
      styles.margin = m ? `${m}px ${mh}px` : `0px ${mh}px`;
    }

    if (mv != null && !mh) {
      styles.margin = m ? `${mv}px ${m}px` : `${mv}px 0px`;
    }

    if (ml != null) {
      styles.marginLeft = `${ml}px`;
    }

    if (mr != null) {
      styles.marginRight = `${mr}px`;
    }

    if (mt != null) {
      styles.marginTop = `${mt}px`;
    }

    if (mb != null) {
      styles.marginBottom = `${mb}px`;
    }

    // paddings
    if (p != null) {
      styles.padding = `${p}px`;
    }

    if (ph != null && pv != null) {
      styles.padding = `${pv}px ${ph}px`;
    }

    if (ph != null && !pv) {
      styles.padding = p ? `${p}px ${ph}px` : `0px ${ph}px`;
    }

    if (pv != null && !ph) {
      styles.padding = p ? `${pv}px ${p}px` : `${pv}px 0px`;
    }

    if (pl != null) {
      styles.paddingLeft = `${pl}px`;
    }

    if (pr != null) {
      styles.paddingRight = `${pr}px`;
    }

    if (pt != null) {
      styles.paddingTop = `${pt}px`;
    }

    if (pb != null) {
      styles.paddingBottom = `${pb}px`;
    }

    if (gap != null) {
      styles.gap = typeof gap === number ? `${gap}px` : gap;
    }

    // width and height

    if (width) {
      styles.width = typeof width === number ? `${width}px` : width;
    }

    if (height) {
      styles.height = typeof height === number ? `${height}px` : height;
    }

    if (minWidth) {
      styles.minWidth = typeof minWidth === number ? `${minWidth}px` : minWidth;
    }

    if (maxWidth) {
      styles.maxWidth = typeof maxWidth === number ? `${maxWidth}px` : maxWidth;
    }

    if (minHeight) {
      styles.minHeight = typeof minHeight === number ? `${minHeight}px` : minHeight;
    }

    if (maxHeight) {
      styles.maxHeight = typeof maxHeight === number ? `${maxHeight}px` : maxHeight;
    }

    // flex

    if (alignItems) {
      styles.alignItems = alignItems;
    }

    if (wrap) {
      styles.flexWrap = wrap;
    }

    if (alignSelf) {
      styles.alignSelf = alignSelf;
    }

    // position

    if (position) {
      styles.position = position;
    }

    if (top != null) {
      styles.top = top;
    }

    if (left != null) {
      styles.left = left;
    }

    if (bottom != null) {
      styles.bottom = bottom;
    }

    if (right != null) {
      styles.right = right;
    }

    if (zIndex) {
      styles.zIndex = zIndex;
    }

    if (background) {
      styles.background = background;
    }

    // text

    if (textAlign) {
      styles.textAlign = textAlign;
    }

    return styles;
  };

  return Container ? (
    <Container
      as={as ? as : "div"}
      ref={innerRef}
      style={getStyles()}
      className={className ? className : ""}
      {...rest}>
      {children}
    </Container>
  ) : (
    <div ref={innerRef} style={getStyles()} className={className ? className : ""} {...rest}>
      {children}
    </div>
  );
};
WrapperContainer.propTypes = {
  children: PropTypes.node,
  Container: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  as: PropTypes.string,
  className: PropTypes.string,
  m: PropTypes.number,
  mh: PropTypes.number,
  mv: PropTypes.number,
  ml: PropTypes.number,
  mr: PropTypes.number,
  mt: PropTypes.number,
  mb: PropTypes.number,
  p: PropTypes.number,
  ph: PropTypes.number,
  pv: PropTypes.number,
  pl: PropTypes.number,
  pr: PropTypes.number,
  pt: PropTypes.number,
  pb: PropTypes.number,
  top: PropTypes.string,
  left: PropTypes.string,
  bottom: PropTypes.string,
  right: PropTypes.string,
  zIndex: PropTypes.string,
  background: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alignItems: PropTypes.string,
  wrap: PropTypes.string,
  alignSelf: PropTypes.string,
  position: PropTypes.string,
  textAlign: PropTypes.string,
  innerRef: PropTypes.object
};

export default WrapperContainer;
